import { z } from 'zod';

import { PickedCivilDayDto } from './civilDate';

export const DAY_NOTE_MAX_LENGTH = 1000;

const DayNoteTextDto = z.string().trim().min(1).max(DAY_NOTE_MAX_LENGTH);

export const ListDayNotesQueryDto = z
  .object({
    // both inclusive; a single day sends the same value twice
    from: PickedCivilDayDto,
    to: PickedCivilDayDto,
  })
  .strict()
  .refine((query) => query.from <= query.to, {
    message: 'VALIDATION__InvalidRange',
    path: ['to'],
  });

export type ApiListDayNotesQueryDto = z.infer<typeof ListDayNotesQueryDto>;

export const CreateDayNoteDto = z
  .object({ businessDate: PickedCivilDayDto, text: DayNoteTextDto })
  .strict();

export type ApiCreateDayNoteDto = z.infer<typeof CreateDayNoteDto>;

export const UpdateDayNoteDto = z.object({ text: DayNoteTextDto }).strict();

export type ApiUpdateDayNoteDto = z.infer<typeof UpdateDayNoteDto>;

export interface ApiDayNote {
  id: string;
  /** The civil day the note belongs to, `yyyy-MM-dd` in the organization zone */
  businessDate: string;
  text: string;
  authorId: string;
  authorName: string;
  createdAt: string;
  updatedAt: string;
  /** Whether the caller may edit or delete it (author or owner) */
  canManage: boolean;
}

export interface ApiDayNotesResponse {
  data: ApiDayNote[];
}
